
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationText } from '@/components/i18n/TranslationText';
import { TranslationButton } from '@/components/i18n/TranslationButton';
import { ArrowRight } from 'lucide-react';
import { NavigateFunction } from 'react-router-dom';

interface CTASectionProps {
  isAuthenticated: boolean;
  navigate: NavigateFunction;
}

export function CTASection({ isAuthenticated, navigate }: CTASectionProps) {
  const { t } = useTranslation();
  
  return (
    <section id="contact" className="py-16 md:py-24 bg-primary text-white">
      <div className="container px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl mb-6">
            <TranslationText i18nKey="cta.title">
              Ready to Transform Your Contract Management?
            </TranslationText>
          </h2>
          <p className="text-lg md:text-xl mb-8 opacity-90">
            <TranslationText i18nKey="cta.subtitle">
              Join hundreds of satisfied customers who have simplified their contract management with Subtrackr
            </TranslationText>
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <TranslationButton
              i18nKey="cta.getStarted"
              size="lg"
              className="h-12 px-8 text-lg bg-white text-primary hover:bg-gray-100 shadow-lg hover:shadow-xl transition-all duration-300"
              onClick={() => navigate(isAuthenticated ? "/contracts" : "/register")}
            >
              <span>{isAuthenticated ? t("goToDashboard") : t("cta.getStarted")}</span>
              <ArrowRight className="ml-2 h-5 w-5" />
            </TranslationButton>
            <TranslationButton
              i18nKey="cta.contactSales"
              size="lg"
              variant="outline"
              className="h-12 px-8 text-lg border-white text-white hover:bg-white/10"
              onClick={() => window.location.href = "mailto:sales@subtrackr.no"}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
